import React from "react";
import Web3 from 'web3'
import Swal from "sweetalert2";
import mint_img from '../assets/images/mint-img.gif'
import persale_users from '../WL_json.json';

//end pre sales - 2021-11-12 07:00 
// data-date="2021-11-10" data-time="19:00"

class Presale extends React.Component
{
  
      constructor(props) {
        super(props);
        this.state = { 
          buffer: null, 
          contract: null, 
          sub_address: null,
          max_items: 0,
          max_mint: 0,
          price: 0,
          total_supply:0,
          minted_babes: 0

        };

        this.textTokens = React.createRef();
        this.contract_address = '0x5A297395C0B56d2D2AdF2e41452970c065D30c32'
        this.abi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"MAX_BY_MINT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_ELEMENTS","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PRICE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"status","type":"bool"}],"name":"activatePresale","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"babes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseTokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"target","type":"address"}],"name":"changeComapnyWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"creatorAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"giveAway","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"giveAways","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_count","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"val","type":"bool"}],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"presale","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_count","type":"uint256"}],"name":"price","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"baseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"limit","type":"uint256"}],"name":"setMaxMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"walletOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdrawAll","outputs":[],"stateMutability":"payable","type":"function"}]
      }


    async componentWillMount() {
      
        await this.loadWeb3()
        await this.loadContractData()
        this.props.setAccount()

    }
 
    async loadWeb3(){
 
      if(window.ethereum){
          window.web3 = new Web3(window.ethereum) 
      }
      else if(window.web3){
          window.web3 = new Web3(window.web3.currentProvider)
      } 
      
    }

    async checkNetwork(){
        if(!window.web3){
          return false;
        }
        return await window.web3.eth.net.getId()

    }
    
    async loadContractData(){
        try{
          // https://mainnet.infura.io/v3/88addc5f4bb4416893789ec3b166e583
          // https://mainnet.infura.io/v3/06627257f2804ae3b3f483fe1de233fc
          const web3 = new Web3('https://mainnet.infura.io/v3/06627257f2804ae3b3f483fe1de233fc');
          //load account
          const myContract = new web3.eth.Contract(this.abi, this.contract_address) 
          const minted_babes = await myContract.methods.babes().call();
          const max_items = await myContract.methods.MAX_ELEMENTS().call()
          const max_mint = await myContract.methods.MAX_BY_MINT().call()


          const wei = await myContract.methods.PRICE().call()
          const price = web3.utils.fromWei(wei, 'ether');
          this.setState({contract:myContract, max_items:max_items,price:price, minted_babes:minted_babes,max_mint:max_mint });
        }
        catch(error){
            console.error(error)
        }

    }  
    
    decrementToken = () => {
      let qty = parseInt(this.textTokens.current.value) || 0
      if(qty){
          this.textTokens.current.value = qty - 1;        
      }  
    }
    
    incrementToken = () => {
      let qty = parseInt(this.textTokens.current.value) || 0
      this.textTokens.current.value = qty + 1;  
    }


    is_whitelisted_user(account){
        if(persale_users.indexOf(account) > -1){
          return true
        }
        return false
    }

    mint = async () => {
 
        const tokens = parseInt(this.textTokens.current.value);
        //check if metamask connected
        if(!this.props.account){
          Swal.fire({  
            icon: 'error',  
            title: 'Warning!',  
            text: 'Please connect to metamask!',  
          });
          return false;
        }

        //check Network         
        // networkId 1 for mainnet network
        // networkId 4 for Rinkeby test network
        const networkId = await this.checkNetwork()
        if(networkId !== 1){         
          Swal.fire({  
            icon: 'error',  
            title: 'Warning!',  
            text: 'Please select mainnet network!',  
          });
          return false;
        }
 
        //check if valid quantity 
        if(tokens > 0){

            //check max mint
            if(tokens > this.state.max_mint){
                Swal.fire({  
                  icon: 'error',  
                  title: 'Warning!',  
                  text: 'Maximum NFTs per transaction exceeded!',  
                });
                return false;
            }
 
            //only for pre sales
            if(!this.is_whitelisted_user(this.props.account)){
                Swal.fire({  
                  icon: 'error',  
                  title: 'Warning!',  
                  text: 'Your account is not whitelisted for presales!',  
                });
              return false;
            }

            //check max total_supply 
            var new_max = tokens + parseInt(this.state.minted_babes);
            if(new_max > parseInt(this.state.max_items)){
              Swal.fire({  
                icon: 'error',  
                title: 'Warning!',  
                text: 'Maximum supply of tokens exceeded!',  
              }); 
              return false;
            }

            try{
                
                const myContract = new window.web3.eth.Contract(this.abi, this.contract_address)
                const tokenPrice = window.web3.utils.toWei(this.state.price, 'ether');
                const payable_amount = (tokenPrice *  tokens).toString();
                
                //const block = await window.web3.eth.getBlock("latest");  
                
                const gas_limit = 200000 * tokens;

                const gas_price = await window.web3.eth.getGasPrice();
                const result = await myContract.methods.mint(tokens).send({
                  from: this.props.account,
                  to: this.contract_address,
                  gasPrice: gas_price,
                  gasLimit: gas_limit,
                  value : payable_amount, 
                })
                
                //console.log("result",result)   

                Swal.fire({  
                  title: 'Success',  
                  type: 'success',  
                  text: 'Successfully Minted NFTs.',  
                });  
                await this.loadContractData()                       
  
            }
            catch(error){
                console.error(error)
                 
            }
    

        }
        else{
          Swal.fire({  
            icon: 'error',  
            title: 'Warning !',  
            text: 'Please enter quantity.',  
          }); 
        }
      
    }
 
 

  render()
  { 
   
    return (
        
        <section className="mint-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 mb-5 text-center">
                <h2><span className="red-text">Get</span> Your <span className="yellow-text">NFTs</span></h2>
              </div>
              <div className="col-md-5">
                <div className="mint-form">
                  <h4 className="mint-text">Mint Price <span className="red-text">{this.state.price}</span></h4>
                  <div className="mint-group">
                    <span className="minus sign"
                    onClick={this.decrementToken}
                    ><i className="fas fa-minus"></i></span>
                    <input type="number"
                      className="count" 
                      ref={this.textTokens} 
                      />
                    <span className="plus sign"
                    onClick={this.incrementToken}
                    ><i className="fas fa-plus"></i></span>
                  </div>
                  <div className="mint-btn-bar text-center">
                    <button className="btn btn-mint" onClick={this.mint}> Mint Now </button>
                  </div>
                  <div className="">
                   {/* <p className="mb-0 pt-4 value_show">mint {this.state.minted_babes}/{this.state.max_items}</p>*/}
                    <p className="mint_detail text-left pt-4"># max of 5 Bored Babes<br/># ERC-721 tokens<br/>
                    # minted on Ethereum Mainnet<br /># metadata stored on IFPS<br/></p>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="mint-img">
                  <img alt="" src={mint_img} />
                </div>
              </div>
            </div>
          </div>
          <p>&nbsp;</p>
          <h4 className="launch-date"> Pre Sale Ends In </h4>
          <h4 className='countdown launch-date' data-date="2021-11-14" data-time="19:00"></h4>
        </section>
      
    )
  }
}
export default Presale;